module.exports = __webpack_public_path__ + "img/healthyCore_banner.ad90f8fd.jpg";